import { render, staticRenderFns } from "./NewIndex.vue?vue&type=template&id=af9bfbce&scoped=true&"
import script from "./NewIndex.vue?vue&type=script&lang=js&"
export * from "./NewIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewIndex.vue?vue&type=style&index=0&id=af9bfbce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9bfbce",
  null
  
)

export default component.exports